import { useFlags } from "launchdarkly-react-client-sdk"

const CARROT_PHONE_SUPPORT_FULL_LAUNCH_DATE = new Date("2024-01-01T12:00:00.000Z")
export function useShowPhoneSupport(): boolean {
  const { enablePhoneSupport } = useFlags()
  const now = new Date()

  return !!(now > CARROT_PHONE_SUPPORT_FULL_LAUNCH_DATE || enablePhoneSupport)
}
